const getAppraisalConfig = (contract) => {
    return {
        title: "Appraisal", 
        taskKey: "appraisal",
        subText: 'In Colorado typically the lender or the buyer is responsible for ordering the appraisal. ', 
        due: `Objection Deadline: ${contract?.data?.dateFields?.appraisal_objection_deadline?.date}`, 
        subSteps: [ 
            {
                title: "Additional Information",
                taskKey: "additionalAppraisalInfo",
                subText: (
                    <>
                    If the appraisal comes in below the purchase price—or if you don’t receive it by the deadline—you have two choices before the objection deadline:
                    <br />
                    <strong>Terminate:</strong> Cancel the contract by notifying the seller in writing.
                    <br />
                    <strong>Object:</strong> Submit a written objection below to challenge the value.
                    <br />
                    If no settlement is reached by the resolution deadline, the contract will end unless you withdraw your objection.
                  </>
                )
            },
            {
                title: "Schedule Appraisal",
                taskKey: "scheduleAppraisal",
                subText: "Schedule your appraisal with a Shishito professional or your own. Mark as complete when done, with the date of appraisal.",
                actionTexts: ["Complete", "Schedule"],
            },
            {
                title: <>Appraisal Objection <small>(Optional)</small></>,
                taskKey: "generateAppraisalObjection",
                subText: "Generate an objection based on your report.",
                actionTexts: ["Generate"]
            },
            {
                title: <>Post Objection <small>(Optional)</small></>,
                taskKey: "postAppraisalObjection",
                subText: "Options after generating an objection.",
                actionTexts: ["Withdraw", "Terminate"]
            },
        ]



        // title: "Title", 
        // taskKey: "title", 
        // subText: 'Title company should provide title documents for you review', 
        // due: `Record Title Objection Deadline: ${contract?.data?.dateFields?.record_title_objection_deadline?.date}`, 
        // subSteps: [ 
        //     {
        //     title: <>Upload Title  <small>(Optional)</small></>, 
        //     subText: ["You can upload your title and have Shishito's AI review it for you"],
        //     taskKey: "uploadReport",
        //     actionTexts: ["Upload"],
        //     type: "upload"
        //     },
        //     {
        //     title: <>Analyze Title  <small>(AI Coming Soon)</small></>, 
        //     // subText: ["Have Shishito's AI analyze your title for you"],
        //     taskKey: "titleAnalyze",
        //     // actionTexts: ["Analyze"]
        //     }, 
        //     {
        //     title: "Title Insurance", 
        //     subText: ["Review the proposed title insurance coverage and consider whether you need additional endorsements based on your intended use of the property"],
        //     taskKey: "titleInsurance",
        //     actionTexts: ["Complete"]
        //     }, 
        //     {
        //     title: "Survey Review", 
        //     subText: ["If needed, consider ordering or reviewing an existing survey and verify property boundaries"],
        //     taskKey: "titleSurveyReview",
        //     actionTexts: ["Complete"]
        //     }, 
        //     {
        //     title: <>Title Objection <small>(Optional)</small></>, 
        //     taskKey: "generateTitleObjection",
        //     subText: "If anything stands out in the title you can generate a title objection.",
        //     actionTexts: ["Generate"]
        //     }, 
        //     {
        //     title: <>Post Objection <small>(Optional)</small></>,
        //     taskKey: "postTitleObjection",
        //     subText: "Options after generating an objection.",
        //     actionTexts: ["Withdraw", "Terminate"]
        //     },
        // ]  
  };
};
  
export default getAppraisalConfig;
  